import { doGet, doPost, doPut } from 'hooks/requests';

export const useAutomatiqIndyService = () => {
    const addToken = (data) => doPost(`/automatiq-indy/add-token/`, data);
    const getToken = (data) => doGet(`/automatiq-indy/get-token/?company_id=${data.companyId}`);
    const updateToken = (data) => doPut(`/automatiq-indy/update-token/`, data);

    return {
        addToken,
        getToken,
        updateToken,
    };
};
